import { render, staticRenderFns } from "./BpDefinitionPositioningImage.vue?vue&type=template&id=4a7259a8&"
import script from "./BpDefinitionPositioningImage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BpDefinitionPositioningImage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BpDefinitionPositioningImage.vue?vue&type=style&index=0&id=4a7259a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports